import type { SxProps, Theme } from "@mui/material";

export const mapAreaTextLinkButtonSx: SxProps<Theme> = {
  fontFamily: '"Gotham", sans-serif',
  fontWeight: 350,
  fontSize: 16,
  lineHeight: "24px",
  textDecoration: "underline",
  textUnderlineOffset: "1px",
  textDecorationThickness: "1px",
  color: "primary.main",
  textTransform: "none",
  boxShadow: "none",
  px: 0,
  minWidth: 0,
  alignSelf: "center",
  "&:hover": {
    color: "primary.main",
    boxShadow: "none",
    textDecoration: "underline",
    backgroundColor: "transparent",
  },
  "&.Mui-disabled": {
    color: "#D8DBE0",
  },
  "&.Mui-disabled:hover": {
    color: "#D8DBE0",
  },
};

export const mapAreaSlotAutocompleteListboxProps = {
  sx: {
    "& .MuiAutocomplete-option": {
      "&:hover, &.Mui-focused": {
        backgroundColor: "#D331001F",
      },
    },
  },
};

export function getMapAreaSlotDeleteIconButtonSx(
  hasSelectedValue: boolean,
): SxProps<Theme> {
  if (!hasSelectedValue) {
    return { mt: 0.25, flexShrink: 0 };
  }
  return {
    mt: 0.25,
    flexShrink: 0,
    color: "#D33100",
    "&:hover": {
      color: "#D33100",
      backgroundColor: "rgba(211, 49, 0, 0.08)",
    },
  };
}

export const mapAreaSlotAutocompleteSx: SxProps<Theme> = {
  flex: 1,
  minWidth: 0,
  "& .MuiOutlinedInput-root": {
    backgroundColor: "background.paper",
  },
};

export const mapAreaApplyButtonSx: SxProps<Theme> = {
  textTransform: "none",
  fontWeight: 400,
  fontSize: 16,
  borderRadius: "100px",
  px: 3,
};
